import { watchers as contactsWatchers } from '../contacts';

import { watchers as commonWatchers } from './commonSagas';
import { watchers as tasksWatchers } from '../tasks';
import { watchers as contactWatchers } from '../users';
import { watchers as analyticsWatchers } from '../analytics';
import { watchers as wazzupWatchers } from '../wazzup';

export default [
  ...commonWatchers,
  ...contactWatchers,
  ...tasksWatchers,
  ...contactsWatchers,
  ...analyticsWatchers,
  ...wazzupWatchers,
];
